module.exports = __webpack_public_path__ + "img/logo-footer.8562e4da.svg";